import * as React from "react";
import { styled } from "@mui/system";
import MUIButton, { ButtonProps } from "@mui/material/Button";

export const Button = styled((props: ButtonProps) => <MUIButton {...props} />, {
  name: "Button",
  slot: "Root",
  overridesResolver: (props, styles) => [styles.root],
})(({ theme }) => ({
  "&.MuiButton-root.MuiButton-sizeSmall": {
    height: 32,
    minHeight: 32,
    minWidth: 59,
  },
  "&.MuiButton-root.MuiButton-sizeMedium": {
    height: 40,
    minHeight: 40,
    minWidth: 64,
    fontSize: 16,
  },
  "&.MuiButton-root.MuiButton-sizeLarge": {
    height: 48,
    minHeight: 48,
    minWidth: 64,
    fontSize: 16,
  },
}));
